import React, { useState, useEffect } from "react";
import { Pie } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { fetchApi } from "../../utlis/axios";

import { Link } from "react-router-dom";
import { FiRefreshCcw } from "react-icons/fi";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const FamilyStatusChart = () => {
  const { access } = useSelector((state) => state.authSlice.userInfo || {});
  const [statusData, setStatusData] = useState({
    accepted: 0,
    rejected: 0,
    inReview: 0,
    hold: 0,
  });
  const [loading, setLoading] = useState(false);

  const getFamilyStatus = async () => {
    try {
      const result = await fetchApi.get("family-graph/", {
        headers: { Authorization: `Bearer ${access}` },
      });
      if (result.status === 200) {
        const apiData = result.data;
        const statusCounts = apiData.reduce((counts, item) => {
          counts[item.status] = (counts[item.status] || 0) + 1;
          return counts;
        }, {});

        setStatusData({
          accepted: statusCounts.accepted || 0,
          rejected: statusCounts.rejected || 0,
          inReview: statusCounts["in-review"] || 0,
          hold: statusCounts.hold || 0,
        });
      }
    } catch (error) {
      console.error("Error loading family status:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getFamilyStatus();
  }, []);

  async function handleRefresh(params) {
    setLoading(true)
    await getFamilyStatus()
    setLoading(false)
  }

  const data = {
    labels: ["Accepted", "Rejected", "In-Review", "Hold"],
    datasets: [
      {
        data: [
          statusData.accepted,
          statusData.rejected,
          statusData.inReview,
          statusData.hold,
        ],
        backgroundColor: ["#6fd195", "#ff746a", "#07dbfa", "#ffae4c"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 6,
          usePointStyle: true,
          padding: 15,
          color: "#000",
          font: {
            size: 15,
            weight: "700",
            family: "roboto",
          },
        },
      },
    },
  };

  return (
    <div className="w-full bg-white shadow rounded-xl p-2.5 sm:p-5">
      <div className="flex items-center justify-between mb-2 w-full ">
        <h2 className="text-[20px] font-semibold text-gray-800">
          Family Status
        </h2>
        <span
          onClick={handleRefresh}
          disabled={loading}
          className={`p-2 w-max rounded-lg cursor-pointer !border-[2px] !border-[#D8D8D8] hover:bg-gray-50 transition bg-transparent shadow-none `}
        >
          <FiRefreshCcw
            className={`text-gray-600 text-lg ${
              loading ? "animate-spin" : ""
            }`}
          />
        </span>
      </div>

      <div className=" mt-3">
        <Link to="/familydetailpage" className="block w-full h-full">
          <div
            className="w-full flex items-center justify-center"
            style={{ height: "-webkit-fill-available" }}
          >
            <Pie data={data} options={options} height={280} />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default FamilyStatusChart;
